import { useEffect, useState } from 'react';
import supabase from '../config/supabaseClient';
import LogOut from './LogOut';
import './Baptisms.css';

function Baptisms() {
  const [baptismalRegistry, setBaptismalRegistry] = useState([]);

  const fetchData = async () => {
    let { data: BaptismalRegistry, error } = await supabase
      .from('BaptismalRegistry')
      .select('*')
      .eq('form_status', 'New');

    if (error) {
      console.error('Error fetching data:', error);
    } else if (BaptismalRegistry.length === 0) {
      console.log('No new registry found. Check back later.');
      setBaptismalRegistry([]);
    } else {
      console.log('Fetched Baptismal Registry:', BaptismalRegistry[0].registry_status.certificate);
      setBaptismalRegistry(BaptismalRegistry);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleCheckboxChange = async (id, field, value) => {
    console.log(`Checkbox for ${field} changed to ${value}`);
    console.log('ID:', id);
    try {
      const updatedRegistryStatus = {
        ...baptismalRegistry.find((item) => item.id === id).registry_status,
        [field]: value,
      };

      const { error } = await supabase
        .from('BaptismalRegistry')
        .update({ registry_status: updatedRegistryStatus })
        .eq('id', id);

      if (error) {
        console.error('Error updating data:', error);
      } else {
        setBaptismalRegistry((prevRegistry) =>
          prevRegistry.map((item) =>
            item.id === id ? { ...item, registry_status: { ...item.registry_status, [field]: value } } : item
          )
        );
      }
    } catch (err) {
      console.error('Unexpected error:', err);
    }
  };

  const handleDelete = (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this record? Selecting 'OK' will delete the record from the database.");
    if (confirmDelete) {
      const deleteRecord = async () => {
        try {
          const { error } = await supabase
            .from('BaptismalRegistry')
            .delete()
            .eq('id', id);

          if (error) {
            console.error('Error deleting record:', error);
          } else {
            setBaptismalRegistry((prevRegistry) =>
              prevRegistry.filter((item) => item.id !== id)
            );
          }
        } catch (err) {
          console.error('Unexpected error:', err);
        }
      };

      deleteRecord();
    }
  };

  const handleFilterChange = async (e) => {
    const filterValue = e.target.value;

    if (filterValue === "Completed") {
      try {
        let { data: completedRecords, error } = await supabase
          .from('BaptismalRegistry')
          .select('*')
          .eq('form_status', 'Complete');

        if (error) {
          console.error('Error fetching completed records:', error);
        } else {
          setBaptismalRegistry(completedRecords);
        }
      } catch (err) {
        console.error('Unexpected error:', err);
      }
    } else if (filterValue === "New Register") {
      try {
        let { data: newRecords, error } = await supabase
          .from('BaptismalRegistry')
          .select('*')
          .eq('form_status', 'New');

        if (error) {
          console.error('Error fetching new records:', error);
        } else {
          setBaptismalRegistry(newRecords);
        }
      } catch (err) {
        console.error('Unexpected error:', err);
      }
    }
  };

  const handleComplete = async (id) => {
    const registryItem = baptismalRegistry.find((item) => item.id === id);

    if (!registryItem.registry_status.certificate || !registryItem.registry_status.registry || !registryItem.registry_status.computer) {
      alert("Not all checkboxes have been completed");
      return;
    }
    const confirmComplete = window.confirm("Selecting 'OK' will update the form status to 'Complete'.");

    if (confirmComplete) {
      try {
        const { error } = await supabase
          .from('BaptismalRegistry')
          .update({ form_status: 'Complete' })
          .eq('id', id);

        if (error) {
          console.error('Error updating form status:', error);
        } else {
          setBaptismalRegistry((prevRegistry) =>
            prevRegistry.map((item) =>
              item.id === id ? { ...item, form_status: 'Complete' } : item
            )
          );
        }
      } catch (err) {
        console.error('Unexpected error:', err);
      }
    }
    fetchData();
  };

  return (
    <div className='baptismal_container'>
      <header className='baptismal_header'>
        <h1>🕊️ Baptisms</h1>
        <div className='header_controls'>
          <select className='filter_select' onChange={handleFilterChange}>
            <option value="New Register">📋 New Register</option>
            <option value="Completed">✅ Completed</option>
          </select>
          <LogOut />
        </div>
      </header>

      {baptismalRegistry.length === 0 ? (
        <div className='empty_state'>
          <h2>No Records Found</h2>
          <p>Check back later for new baptism registrations.</p>
        </div>
      ) : (
        <ul className='baptism_list'>
          {baptismalRegistry.map((item, index) => (
            <li key={index} className='baptism_card'>
              <header className='card_header'>
                <div className='child_info'>
                  <h3>👶 {item.childs_info.full_name}</h3>
                  <div className='child_details'>
                    <p>📅 Born: {item.childs_info.birthday}</p>
                    <p>📍 Place: {item.childs_info.birth_place}</p>
                  </div>
                </div>
              </header>

              <main className='card_main'>
                <div className='info_sections'>
                  <section className='info_section'>
                    <h2>👪 Parents</h2>
                    <div className='section_content'>
                      <div className='info_row'>
                        <p className='info_item'><strong>Father:</strong> {item.parents_info.fathers_name}</p>
                        <p className='info_item'><strong>Mother:</strong> {item.parents_info.mothers_name}</p>
                      </div>
                      <div className='info_row'>
                        <p className='info_item'><strong>Father's Religion:</strong> {item.parents_info.fathers_religion}</p>
                        <p className='info_item'><strong>Mother's Religion:</strong> {item.parents_info.mothers_religion}</p>
                      </div>
                      <div className='info_row'>
                        <p className='info_item'><strong>Married by Priest:</strong> {item.parents_info.married_by_priest ? 'Yes' : 'No'}</p>
                        <p className='info_item'><strong>Parishioner:</strong> {item.parents_info.registered_members_of_the_parish ? 'Yes' : 'No'}</p>
                      </div>
                    </div>
                  </section>

                  <section className='info_section'>
                    <h2>🙏 Godparents</h2>
                    <div className='section_content'>
                      <div className='info_row'>
                        <p className='info_item'><strong>Godfather:</strong> {item.godparents_info.godfathers_name || 'Not specified'}</p>
                        <p className='info_item'><strong>Godmother:</strong> {item.godparents_info.godmothers_name || 'Not specified'}</p>
                      </div>
                      <div className='info_row'>
                        <p className='info_item'><strong>Godfather's Religion:</strong> {item.godparents_info.godfathers_religion || 'Not specified'}</p>
                        <p className='info_item'><strong>Godmother's Religion:</strong> {item.godparents_info.godmothers_religion || 'Not specified'}</p>
                      </div>
                    </div>
                  </section>

                  <section className='info_section'>
                    <h2>📅 Date Info</h2>
                    <div className='section_content'>
                      <p className='info_item'><strong>Preparation Date:</strong> {item.date_info.preparation_date || 'TBD'}</p>
                      <p className='info_item'><strong>Baptism Date:</strong> {item.date_info.baptism_date || 'TBD'}</p>
                    </div>
                  </section>

                  <section className='info_section contact_section'>
                    <h2>📞 Contact</h2>
                    <div className='contact_info'>
                      <p className='info_item'><strong>📧 Email:</strong> {item.email}</p>
                      <p className='info_item'><strong>📱 Phone:</strong> {item.phone_number}</p>
                    </div>
                  </section>
                </div>
              </main>

              <footer className='card_footer'>
                <div className='checkbox_group'>
                  <div className='checkbox_item'>
                    <input
                      type="checkbox"
                      id={`cert_${item.id}`}
                      checked={item.registry_status.certificate}
                      onChange={(e) =>
                        handleCheckboxChange(item.id, 'certificate', e.target.checked)
                      }
                    />
                    <label htmlFor={`cert_${item.id}`}>📜 Certificate Done</label>
                  </div>
                  <div className='checkbox_item'>
                    <input
                      type="checkbox"
                      id={`registry_${item.id}`}
                      checked={item.registry_status.registry}
                      onChange={(e) =>
                        handleCheckboxChange(item.id, 'registry', e.target.checked)
                      }
                    />
                    <label htmlFor={`registry_${item.id}`}>📚 Entered into Registry</label>
                  </div>
                  <div className='checkbox_item'>
                    <input
                      type="checkbox"
                      id={`computer_${item.id}`}
                      checked={item.registry_status.computer}
                      onChange={(e) =>
                        handleCheckboxChange(item.id, 'computer', e.target.checked)
                      }
                    />
                    <label htmlFor={`computer_${item.id}`}>💻 Entered into Computer</label>
                  </div>
                </div>
                <div className='action_buttons'>
                  <button className='action_button edit_btn'>✏️ Edit</button>
                  <button className='action_button delete_btn' onClick={() => handleDelete(item.id)}>🗑️ Delete</button>
                  <button className='action_button complete_btn' onClick={() => handleComplete(item.id)}>✅ Complete</button>
                </div>
              </footer>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default Baptisms;